import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import workerInductionMessages from './worker-induction.messages';
import WorkerInduction from './worker-induction.mapper';

const functions = {
  get,
  getForWorker,
  getByToken,
};

export default {
  ...functionsWithNotifications(functions, workerInductionMessages),
};

const workerInductionApi = new ApiService({ disableCache: true });

async function get(workerInductionUuid) {
  const response = await workerInductionApi.get(`worker_inductions/${workerInductionUuid}`);
  return new WorkerInduction(response.data.data);
}

async function getForWorker(workerUuid) {
  const response = await workerInductionApi.get(`workers/${workerUuid}/worker_inductions`);
  return response.data.data.map(workerInduction => new WorkerInduction(workerInduction));
}

async function getByToken(token) {
  const response = await workerInductionApi.get(`worker_inductions/check/${token}`);
  return response.data.data.attributes;
}
